<div class="receivables-import-row-details-view-container" *ngIf="receivablesImportsRowObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + receivablesImportsRowObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="receivablesImportsRowObject.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).receivables.write"
      *ngIf="[RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION].includes(receivablesImportsRowObject?.status.key)  && receivablesImportsRowObject.registrationPartner.registrationUuid !== null"
      mat-stroked-button
      (click)="newRow()"
    ><span>Nowa</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION, RECEIVABLES_IMPORT_ROW_STATUS_NEW ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button
      (click)="rejectedRow()"
    ><span>Odrzucona</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID, RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED ].includes(receivablesImportsRowObject?.status.key)"
      [disabled]=" !receivablesImportsRowObject.receivablesBalance &&  [RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button
      (click)="cancelRow()"
    ><span>Anulowana</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [ RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED, RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button
      (click)="unpaidRow()"
    ><span>Nieopłacona</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [  RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button
      (click)="paidToTuRow()"
    ><span>Opłacona do TU</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [  RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED, RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button
      (click)="paidToASFRow()"
    ><span>Opłacona do ASF</span></button>


    <button
      *ngIf="(userPermissions | async).receivables.write  && [RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID ].includes(receivablesImportsRowObject?.status.key)"
      [disabled]=" !receivablesImportsRowObject.receivablesBalance &&  [RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID ].includes(receivablesImportsRowObject?.status.key)"

      mat-stroked-button
      (click)="toCancelRow()"
    ><span>Zgłoś</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID ].includes(receivablesImportsRowObject?.status.key)"
      [disabled]=" !receivablesImportsRowObject.receivablesBalance &&  [RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button  (click)="policyOverride()">
      <span>Przepięcie Polisy</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && receivablesImportsRowObject.registrationPartner.registrationUuid === null && [RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button (click)="registrationChange()"
    ><span>Przypisz strukturę</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION, RECEIVABLES_IMPORT_ROW_STATUS_NEW].includes(receivablesImportsRowObject?.status.key)  && receivablesImportsRowObject.registrationPartner.registrationUuid !== null"
      mat-stroked-button (click)="registrationChange()"
    ><span>Zmień rejestrację</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.write  && [RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED, RECEIVABLES_IMPORT_ROW_STATUS_REJECTED ].includes(receivablesImportsRowObject?.status.key)"
      mat-stroked-button
      (click)="restoreRow()"
    ><span>Do weryfikacji</span></button>

    <button
      [disabled]="!(userPermissions | async).receivables?.read"
      *ngIf="receivablesImportsRowObject.fileName"
      mat-stroked-button
      (click)="downloadDocument()"
    ><span>Pobierz dokument</span></button>

    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>Do weryfikacji</span></button>


  </div>
<!--  <div fxLayout="row" fxLayoutGap="15px">-->
<!--    <button [disabled]="!(userPermissions | async).user.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>-->
<!--  </div>-->
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane polisy</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="TU" [value]="receivablesImportsRowObject?.insuranceCompany?.name"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Importer" [value]="receivablesImportsRowObject?.import?.importer?.name"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer polisy" [value]="receivablesImportsRowObject?.policyNumber"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data zawarcia" [value]="receivablesImportsRowObject?.conclusionAt| date:'y-MM-dd'"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Data wymagalności" [value]="receivablesImportsRowObject?.paymentDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail *ngIf="receivablesImportsRowObject?.status.key === RECEIVABLES_IMPORT_ROW_STATUS_PAID" header="Data rozliczenia" [value]="receivablesImportsRowObject?.changeToPaidAt| date:'y-MM-dd'"></app-detail>
                <app-detail *ngIf="receivablesImportsRowObject?.status.key !== RECEIVABLES_IMPORT_ROW_STATUS_PAID" header="Data rozliczenia" [value]="'-'"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane OFWCA</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Imię i nazwisko" [value]="receivablesImportsRowObject?.ofwcaFullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <div fxFlex="50">
                  <app-detail header="PESEL" [value]="receivablesImportsRowObject?.ofwcaPesel"></app-detail>
                </div>
                <div fxFlex="50">
                  <app-detail header="RAU" [value]="receivablesImportsRowObject?.ofwcaRau"></app-detail>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <div fxFlex="50">
                  <app-detail header="Typ identyfikatora" [value]="receivablesImportsRowObject?.ofwcaIdType?.name"></app-detail>
                </div>
                <div fxFlex="50">
                  <app-detail header="Identyfikator" [value]="receivablesImportsRowObject?.ofwcaIdNumber"></app-detail>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane klienta</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Imię i nazwisko klienta" [value]="receivablesImportsRowObject?.customerName"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane należności</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                  <app-detail header="Kwota należności" >
                  {{(receivablesImportsRowObject.amountDue === null ? 0 : receivablesImportsRowObject.amountDue) | number:'1.2-2'}} zł
                </app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Liczba rat" >
                  {{ receivablesImportsRowObject?.numberOfInstallments }}
                </app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="receivablesImportsRowObject?.registrationPartner?.ofwcaFullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Umowa"
                            [value]="receivablesImportsRowObject?.registrationPartner?.contractFullName"
                ></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="receivablesImportsRowObject?.registrationPartner?.partnerFullName"  [link]="receivablesImportsRowObject?.registrationPartner?.partnerUuid ? ['/partnerzy/szczegoly', receivablesImportsRowObject?.registrationPartner?.partnerUuid] : undefined"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail  header="Rejestracja" [value]="receivablesImportsRowObject?.registrationPartner?.registrationName ? receivablesImportsRowObject?.registrationPartner?.registrationName  + ' ' + receivablesImportsRowObject?.registrationPartner?.ofwcaFullName : '' "
                            [link]="receivablesImportsRowObject.registrationPartner?.registrationUuid ? ['/rejestracje/szczegoly', receivablesImportsRowObject?.registrationPartner?.registrationUuid] : undefined">
                </app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Regionalny majątek" [value]="receivablesImportsRowObject?.registrationPartner?.partnerAssetsRegional"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Saldo numer" [value]="receivablesImportsRowObject?.receivablesBalance?.recordId"
                            [link]="receivablesImportsRowObject.receivablesBalance?.uuid ? ['/naleznosci/salda/szczegoly', receivablesImportsRowObject?.receivablesBalance?.uuid ] : undefined"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Saldo Partner" [value]="receivablesImportsRowObject?.receivablesBalance?.partner?.shortName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Saldo OFWCA" [value]="receivablesImportsRowObject?.receivablesBalance?.ofwca?.fullName"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dodatkowe informacje</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
                  <div fxFlex="50">
                    <app-detail header="Data importu" [value]="receivablesImportsRowObject?.createdAt| date:'y-MM-dd'"></app-detail>
                  </div>
                  <div fxFlex="50">
                    <app-detail header="Firma" [value]="receivablesImportsRowObject?.company?.name"></app-detail>
                  </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Uwagi" [value]="receivablesImportsRowObject?.note"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="receivablesImportsRowObject?.reasonLackConfirmation">
              <div fxFlex="100">
                <app-detail header="Powód braku potwierdzenia " [value]="receivablesImportsRowObject?.reasonLackConfirmation"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="receivablesImportsRowObject?.reasonForCancelled">
              <div fxFlex="100">
                <app-detail header="Powód anulowania " [value]="receivablesImportsRowObject?.reasonForCancelled"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </div>


  </div>
</div>
